<template>
  <div class="loginWrapper">
    <!-- <img src="../../static/img/left-background.png" alt /> -->
    <div class="login">
      <h1>登录</h1>
      <div class="usernameWrapper">
        <input
          placeholder="请输入账号"
          v-model.trim="username"
          class="username"
        />
        <i @click="clearValue"></i>
      </div>
      <input
        placeholder="请输入密码"
        v-model.trim="password"
        class="password"
        type="password"
      />
      <div class="guy">
        <div class="wrap">
          <el-checkbox
            @click="state = !state"
            v-model="state"
            checked-color="#c2993f"
            icon-size="1.1rem"
            >记住密码</el-checkbox
          >
        </div>
        <p class="forget">
          <a>忘记密码？</a>
        </p>
      </div>
      <button type="button" class="login-but" @click="login">登录</button>
    </div>
    <div class="yum">
      Copyright© 2021 杭州汇合智能科技有限公司
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        style="color: rgb(255, 255, 255); text-decoration: none;"
        class="__web-inspector-hide-shortcut__"
        >浙ICP备14030516号-8</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      state: false
    };
  },
  computed: {
    height() {
      return document.documentElement.clientHeight;
    }
  },
  created() {
    this.getCookie();
  },
  methods: {
    //   保存账号密码
    setCookie(username, password, num) {
      window.document.cookie = "userName=" + username + "";
      window.document.cookie = "passWord=" + password + "";
    },
    //读取保存后的cookie
    getCookie() {
      //  console.log("---");
      if (document.cookie.length > 0) {
        const cookieArr1 = document.cookie.split(";");
        for (let i in cookieArr1) {
          this.state = true;
          const cookieArr2 = cookieArr1[i].split("=");
          //避免输入中含有空格，消除文本框空格
          cookieArr2[0] = cookieArr2[0].replace(/\s+/g, "");
          cookieArr2[1] = cookieArr2[1].replace(/\s+/g, "");
          if (cookieArr2[0] == "userName") {
            //读取cookie然后进行解码
            this.username = cookieArr2[1];
          } else if (cookieArr2[0] == "passWord") {
            this.password = cookieArr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie() {
      this.setCookie("", "", -1);
    },
    clearValue() {
      this.username = "";
    },
    login() {
      this.$post("/authorization/managerUser/login", {
        login_name: this.username,
        pwd: this.password
      }).then(res => {
        console.log(res);
        if (res.message === "成功") {
          console.log(345678, res);
          localStorage.setItem("managerInfo", res.data.managerInfo.id);
          localStorage.setItem("token", res.data.managerToken);
          this.$message({
            message: res.message,
            type: "success"
          });

          if (this.state) {
            this.setCookie(this.username, this.password);
          } else {
            this.clearCookie();
          }
          this.$router.push({ path: "/index" });
        } else {
          this.$message({
            duration: 1000,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.yum {
  height: 30px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: #33cbcc;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
}
.loginWrapper {
  display: flex;
  height: 936px;
}
.loginWrapper > img {
  width: 70%;
}
.login {
  display: flex;
  width: 450px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
.login h1 {
  position: absolute;
  top: 20px;
  font-size: 50px;
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 140px;
}
.login select {
  background: #f0f0f0;
  width: 450px;
  height: 60px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  border: none;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(153, 153, 153, 1);
  appearance: none;
  margin-top: 78px;
}

.role {
  background: #f0f0f0;
  width: 450px;
  height: 60px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  border: none;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(153, 153, 153, 1);
  appearance: none;
}

.login input {
  display: block;
  box-sizing: border-box;
  background: #f0f0f0;
  width: 450px;
  height: 60px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  border: none;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(153, 153, 153, 1);
}

.username,
.password,
.forget {
  display: inline-block;
  margin-top: 10px;
}
.usernameWrapper {
  /* display: flex; */
  position: relative;
}
.usernameWrapper > i {
  display: block;
  width: 15px;
  height: 15px;
  background-image: url("../../static/img/delete.png");
  background-repeat: no-repeat;
  position: absolute;
  left: 402px;
  top: 34px;
  cursor: pointer;
}
.forget {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  opacity: 0.7;
  width: 450px;
  text-align: right;
}
.forget > a {
  color: rgba(51, 203, 204, 1);
}
.loginBtn {
  width: 300px;
  height: 50px;
  margin-top: 99px;
  background: #33cbcc;
  font-size: 25px;
  font-weight: 400;
}
.login-but {
  width: 300px;
  height: 50px;
  margin-top: 99px;
  background: #33cbcc;
  font-size: 23px;
  font-weight: 400;
  border: none;
  color: #fff;
  cursor: pointer;
}
.guy {
  position: relative;
  /* width: 80%; */
  margin: 0 auto;
  display: flex;
  margin-top: 30px;
  align-items: center;
}
.guy > .wrap > .el-checkbox >>> .el-checkbox__label {
  font-size: 16px;
  color: rgba(51, 203, 204, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue